const IMAGES = ['tif', 'tiff', 'bmp', 'png', 'jpg', 'jpeg', 'gif', 'psd', 'eps', 'ai', 'indd', 'raw'];
const WORD = ['doc', 'docx', 'docm', 'dot', 'dotm', 'dotx'];
const EXCEL = ['csv', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xls', 'xlt', 'xlam'];
const OPENOFFICE = ['odt', 'ods', 'odp', 'odg'];
const PRESENTATION = ['otp', 'ppt', 'pptx', 'odp', 'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppsx', 'pptm'];
const XML = ['xml'];
const PDF = ['pdf'];

export function getFileIcon(fileName) {
  if (typeof fileName !== 'string') {
    return 'icon-file-empty';
  }

  const ext = fileName.split('.').pop().toLowerCase();

  if (IMAGES.indexOf(ext) >= 0) {
    return 'icon-file-picture';
  }

  if (WORD.indexOf(ext) >= 0) {
    return 'icon-file-word';
  }

  if (EXCEL.indexOf(ext) >= 0) {
    return 'icon-file-excel';
  }

  if (XML.indexOf(ext) >= 0) {
    return 'icon-file-xml';
  }

  if (PDF.indexOf(ext) >= 0) {
    return 'icon-file-pdf';
  }

  if (OPENOFFICE.indexOf(ext) >= 0) {
    return 'icon-file-openoffice';
  }

  if (PRESENTATION.indexOf(ext) >= 0) {
    return 'icon-file-presentation';
  }

  return 'icon-file-empty';
}

export function getFileColorForIcon(fileIcon) {
  switch (fileIcon) {
    case 'icon-file-openoffice':
    case 'icon-file-word':
      return 'text-primary-300';

    case 'icon-file-pdf':
      return 'text-danger-300';

    case 'icon-file-excel':
      return 'text-success-300';

    case 'icon-file-presentation':
      return 'text-warning-300';

    case 'icon-file-picture':
      return 'text-brown-300';

    default:
      return null;
  }
}
